import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import CloseIcon from '@material-ui/icons/Close';
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  Paper,
  Grid,
  Box,
  Fade,
  Modal,
  Backdrop,
} from "@material-ui/core";
  const maskIdentification = (identificacion) => {
    if (typeof identificacion !== 'string') return identificacion;
    if (identificacion.length <= 4) return 'xxxx';
    return identificacion.slice(0, -4) + 'xxxx';
  };
const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 600,
    margin: 'auto',
    marginTop: theme.spacing(5),
    outline: 'none',
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  modalPaper: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    maxWidth: 700,
    width: '90%',
    maxHeight: '90vh',
    overflowY: 'auto',
    outline: 'none',
  },
}));

export default function RecipeReviewCard(props) {
  const classes = useStyles();
  const [config, setConfig] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(true); // abrir modal por defecto

  useEffect(() => {
    fetch('config.json')
      .then(response => response.json())
      .then(configData => setConfig(configData));
  }, []);

  const handleModalClose = () => {
    setIsModalOpen(false);
    if (props.closeAditionalInfo) props.closeAditionalInfo();
  };

  const api_url = config.api_images_server;

  return (
    <Modal
      open={isModalOpen}
      onClose={handleModalClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={isModalOpen}>
        <div className={classes.modalPaper}>
          <Card className={classes.root}>
            <CardHeader
              action={
                <IconButton aria-label="close" onClick={handleModalClose}>
                  <CloseIcon />
                </IconButton>
              }
              title={"INFORMACIÓN DEL PREDIO"}
            />
            {props.valoresTabla?.foto && (
              <CardMedia
                className={classes.media}
                image={`${api_url}/CATASTROIMG/${props.valoresTabla.foto}`}
                title="Catastro"
              />
            )}
            <CardContent>
              <Typography variant="h6" style={{ marginBottom: 16 }}>
                DATOS DEL PREDIO
              </Typography>

              <TableContainer component={Paper}>
                <Table size="small">
                  <TableBody>
                    <TableRow>
                      <TableCell><strong>CLAVE CATASTRAL:</strong> {props.valoresTabla?.claveCatastral}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><strong>ESTADO:</strong> {props.valoresTabla?.estado}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><strong>TIPO:</strong> {props.valoresTabla?.tipoLote}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><strong>DERECHOS Y ACCIONES:</strong> {props.valoresTabla?.derechosAcciones}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><strong>PROPIEDAD HORIZONTAL:</strong> {props.valoresTabla?.tipoLotePropiedad}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><strong>PARROQUIA:</strong> {props.valoresTabla?.parroquia}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><strong>BARRIO:</strong> {props.valoresTabla?.barrio}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>

            <CardContent>
              <Typography variant="h6" style={{ marginBottom: 16 }}>
                DATOS DEL TITULAR
              </Typography>

              <TableContainer component={Paper}>
                <Table size="small">
                  <TableBody>
                    <TableRow>
                      <TableCell><strong>CEDULA/RUC:</strong> {maskIdentification(props.valoresTabla?.cedula)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><strong>CONTRIBUYENTE:</strong> {props.valoresTabla?.propietario}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><strong>TIPO DE PROPIETARIO:</strong> {props.valoresTabla?.tipoPropietario}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><strong>PRINCIPAL:</strong> {props.valoresTabla?.tipoPrincipal}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><strong>ALICUOTA:</strong> {props.valoresTabla?.alicuota}</TableCell>
                    </TableRow>

                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
            <CardContent>
              <Typography variant="h6" style={{ marginBottom: 16 }}>
                DATOS VALORACIÓN
              </Typography>

              <TableContainer component={Paper}>
                <Table size="small">
                  <TableBody>
                    <TableRow>
                      <TableCell><strong>AVALUO COMERCIAL:</strong> {props.valoresTabla?.avaluoComercia}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><strong>AVALUO DEL TERRENO:</strong> {props.valoresTabla?.avaluoTerreno}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><strong>AVALUO CONSTRUCCION:</strong> {props.valoresTabla?.avaluoContruccion}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>

            <CardContent>
              <Typography variant="h6" style={{ marginBottom: 16 }}>
                DATOS DEL LOTE
              </Typography>

              <TableContainer component={Paper}>
                <Table size="small">
                  <TableBody>
                    <TableRow>
                      <TableCell><strong>NUMERO DE LOTE:</strong> {props.valoresTabla?.numLote}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><strong>TIPO:</strong> {props.valoresTabla?.tipoLotePropiedad}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><strong>REGULARIZADO:</strong> {props.valoresTabla?.regularizado}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><strong>AREA DE ESCRITURA:</strong> {props.valoresTabla?.areaEscritura}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><strong>AREA GRAFICA:</strong> {props.valoresTabla?.areaGrafica}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><strong>AREA DE CONSTRUCCION:</strong> {props.valoresTabla?.areaConstruccion}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><strong>FRENTE:</strong> {props.valoresTabla?.frente}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><strong>FECHA DE ESCRITURA:</strong> {props.valoresTabla?.fechaEscritura}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><strong>FECHA DE INSCRIPCION:</strong> {props.valoresTabla?.fechaInscripcion}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>

          </Card>
        </div>
      </Fade>
    </Modal>
  );
}
